<template>
  <LayoutGradient :title="$t('dexpara.resultado.titulo_pagina')" icon="fa-random" :content-overflow="false">
    <b-card-group class="m-3 mt-n10 bg-transparent border-0" body-class="p-0" deck>
      <b-card class="col-md-9" body-class="p-0">
        <DeXParaFilter @search="searchExams"/>

        <TableSimple
            :fields="fields"
            :items="exams"
            :loading="examsIsLoading || DeXParaIsLoading"
            :paginator="examsPagination"
            :text-empty="$t('dexpara.resultado.exams.empty')"
            thead-class="h5 text-center"
            @paginate="paginateExams"
            borderless
            marginless
            hover
        >
          <template v-slot:cell(origin)="linha">
            <b-input-group :class="{
                'bg-white': integrationsSelected.origin,
                'bg-gray-200': !integrationsSelected.origin
              }">
              <form-group-float-label
                  class="flex-fill"
                  :label="linha.item.name"
                  :input-name="`input-origem-${linha.index}`"
                  input-class="border-0"
                  :disabled="!integrationsSelected.origin"
                  v-model="linha.item.origin_code"
                  mandatory>
                <template v-slot:action-button>
                  <b-button v-if="linha.item.origin_has_custom_parse"
                            variant="primary"
                            size="sm"
                            :disabled="!integrationsSelected.origin"
                            @click="$store.commit('tuevs/exams/updateExam',{id:linha.item.id, field: 'origin_has_custom_parse', value: false})"
                            rounded pill>Parser
                  </b-button>
                  <b-button v-else
                            variant="outline-primary"
                            size="sm"
                            :disabled="!integrationsSelected.origin"
                            @click="$store.commit('tuevs/exams/updateExam',{id:linha.item.id, field: 'origin_has_custom_parse', value: true})"
                            rounded pill>Parser
                  </b-button>
                </template>
              </form-group-float-label>
            </b-input-group>

            <div v-if="linha.item.origin_has_custom_parse" class="customParse mt-2">
              <label>{{ $t('dexpara.resultado.exams.parse_personalizado') }}</label>
              <b-form-select :id="`parse-select-origem-${linha.index}`"
                             :disabled="!linha.item.origin_has_custom_parse"
                             v-model="linha.item.integration_helpers_id"
                             :options="integrationHelpers | idNameToValueText"/>
            </div>

            <b-button :id="`link-details-${linha.index}`" variant="link" @click="openDetails(linha);"
                      size="sm" class="p-0">
              {{ $t('dexpara.filtros.detalhes') }}
            </b-button>
            <b-button size="sm" variant="link" @click="openLogs(linha);" v-if="permissions.includes('logs.detail')">
              {{ $t('dexpara.filtros.logs') }}
            </b-button>
          </template>
          <template v-slot:cell(destination)="linha">
            <b-input-group :class="{
                'bg-white': integrationsSelected.destination,
                'bg-gray-200': !integrationsSelected.destination
              }">
              <form-group-float-label
                  class="flex-fill"
                  :label="linha.item.name"
                  :input-name="`input-destino-${linha.index}`"
                  input-class="border-0"
                  :disabled="!integrationsSelected.destination"
                  v-model="linha.item.destination_code"
                  mandatory>
                <template v-slot:action-button>
                  <b-button v-if="linha.item.destination_has_custom_parse"
                            variant="primary"
                            size="sm"
                            :disabled="!integrationsSelected.destination"
                            @click="$store.commit('tuevs/exams/updateExam',{id:linha.item.id, field: 'destination_has_custom_parse', value: false})"
                            rounded pill>Parser
                  </b-button>
                  <b-button v-else
                            variant="outline-primary"
                            size="sm"
                            :disabled="!integrationsSelected.destination"
                            @click="$store.commit('tuevs/exams/updateExam',{id:linha.item.id, field: 'destination_has_custom_parse', value: true})"
                            rounded pill>Parser
                  </b-button>
                </template>
              </form-group-float-label>
            </b-input-group>

            <div v-if="linha.item.destination_has_custom_parse" class="customParse mt-2">
              <label>{{ $t('dexpara.resultado.exams.parse_personalizado') }}</label>
              <b-form-select :id="`parse-select-destino-${linha.index}`"
                             :disabled="!linha.item.destination_has_custom_parse"
                             v-model="linha.item.integration_helpers_id"
                             :options="integrationHelpers | idNameToValueText"/>
            </div>
          </template>
          <template v-slot:row-details="{item, index}">
            <b-table stacked :fields="details" :items="formatDetails(item)" v-show="showDetails[index]" />
            <div v-show="showLogs[index]">
              <b-card :title="$t('dexpara.log.origem')">
                <b-card-text v-if="logItems[index] && logItems[index].logOrigin">
                  {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logOrigin.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logOrigin.updated_at)}}.
                </b-card-text>
                <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
                <button v-if="logItems[index] && logItems[index].logOrigin" class="btn btn-outline-info" @click="openHistory(logItems[index].logOrigin.auditable_id)">Ver Histórico</button>
              </b-card>
              <b-card :title="$t('dexpara.log.destino')" class="mt-2">
                <b-card-text v-if="logItems[index] && logItems[index].logDestination">
                  {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logDestination.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logDestination.updated_at)}}.
                </b-card-text>
                <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
                <button v-if="logItems[index] && logItems[index].logDestination" class="btn btn-outline-info" @click="openHistory(logItems[index].logDestination.auditable_id)">Ver Histórico</button>
              </b-card>
            </div>
          </template>
        </TableSimple>
      </b-card>

      <DeXParaIntegrationsCopy class="col-md-3 sticky-top h-100" @change="updateIntegrations" @save="persistDeXPara" @save-copy="(evt) => persistDeXParaCopy(evt)"/>
    </b-card-group>
  </LayoutGradient>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import DeXParaFilter from "@/pages/dexpara/components/DeXParaFilter";
import LayoutGradient from "@/templates/LayoutGradient";
import DeXParaRepository from "@/repositories/dexpara/ResultRepository";
import {mapActions, mapGetters} from 'vuex';
import TableSimple from "@/components/TableSimple";
import FormGroupFloatLabel from "@/components/FormGroupFloatLabel";
import DeXParaIntegrationsCopy from "@/pages/dexpara/components/DeXParaIntegrationsCopy";
import AuditRepository from "@/repositories/audit/AuditRepository";
import moment from "moment";

export default {
  name: "DeXParaResultado",
  components: {
    DeXParaIntegrationsCopy,
    TableSimple,
    FormGroupFloatLabel,
    DeXParaFilter,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      filters: 'dexpara/filters',
      exams: 'tuevs/exams/all',
      examsIsLoading: 'tuevs/exams/isLoading',
      examsPagination: 'tuevs/exams/pagination',
      deXparas: 'dexpara/result/all',
      DeXParaIsLoading: 'dexpara/result/isLoading',
      integrationHelpers: 'integrationHelper/all',
      examsByType: 'tuevs/exams/allByType',
    })
  },
  data() {
    return {
      integrationsSelected: {
        origin: null,
        destination: null
      },
      fields: [
        {key: 'origin', label: this.$t('dexpara.resultado.exams.origem')},
        {key: 'destination', label: this.$t('dexpara.resultado.exams.destino')}
      ],
      details: [
        {key: 'component', label: this.$t('dexpara.filtros.componente')},
        {key: 'specimen', label: this.$t('dexpara.filtros.material')},
        {key: 'methods', label: this.$t('dexpara.filtros.metodos')},
        {key: 'scale', label: this.$t('dexpara.filtros.escala')},        
        {key: 'time', label: this.$t('dexpara.filtros.tempos')}
      ],
      showDetails: [],
      showLogs: [],
      logItems: [],
      permissions: [],
      canAccessRoot: false
    }
  },
  methods: {
    ...mapActions([
      'integration/search',
      'dexpara/result/listAll',
      'tuevs/exams/listAll',
      'integrationHelper/listAll',
      'tuevs/exams/findByType'
    ]),
    openDetails(linha) {
      if (!this.showDetails[linha.index] || this.showDetails[linha.index] === false) {
        if (linha.detailsShowing === true && this.showLogs[linha.index] === true) {
          linha.toggleDetails();
        }
        
        this.showLogs[linha.index] = false;
        this.showDetails[linha.index] = true;
        linha.toggleDetails();
        return;
      }

      if (this.showDetails[linha.index] === true) {
        this.showLogs[linha.index] = false;
        this.showDetails[linha.index] = false;
        linha.toggleDetails();
        return;
      }
    },
    async openLogs(linha) {
      if (!this.showLogs[linha.index] || this.showLogs[linha.index] === false) {
        this.logItems[linha.index] = await this.formatLogDetails(linha.item);        
        
        if (linha.detailsShowing === true && this.showDetails[linha.index] === true) {          
         linha.toggleDetails();
        }

        this.showDetails[linha.index] = false;
        this.showLogs[linha.index] = true;
        linha.toggleDetails();
        return;
      }      

      if (this.showLogs[linha.index] === true) {
        this.showDetails[linha.index] = false;
        this.showLogs[linha.index] = false;
        linha.toggleDetails();
        return;
      }
    },
    formatDetails(item) {
      let obj = {}
      if (item.component && item.component.name) {
        obj.component = item.component.name
      }
      if (item.methods) {
        obj.methods = item.methods.map(m => m.name).join(', ')
      }
      if (item.scale && item.scale.name) {
        obj.scale = item.scale.name
      }
      if (item.specimen && item.specimen.name) {
        obj.specimen = item.specimen.name
      }
      if (item.time && item.time.name) {
        obj.time = item.time.name
      }
      return [obj]
    },
    async formatLogDetails(exam) {
      let obj = {}
      let logOrigin = null
      let logDestination = null
      if (!this.deXparas || this.deXparas.length === 0) {
        return obj
      }

      let originMapped = this.deXparas.filter(d => d.tuevs_exam_id === exam.id && d.code === exam.origin_code);
      let destinationMapped = this.deXparas.filter(d => d.tuevs_exam_id === exam.id && d.code === exam.destination_code);

      if (originMapped && originMapped.length > 0) {
        logOrigin = await AuditRepository.getLastByModelId(originMapped[0].id).then(async (response) => {          
          return response.data.data;          
        })
      }

      if (destinationMapped && destinationMapped.length > 0) {
        logDestination = await AuditRepository.getLastByModelId(destinationMapped[0].id).then(async (response) => {          
          return response.data.data;
        })
      }

      obj.logOrigin = logOrigin;
      obj.logDestination = logDestination;
      return obj
    },
    openHistory(auditId) {
      const routeData = this.$router.resolve({ name: 'logs.detail', params: { id: auditId } });
      window.open(routeData.href, '_blank');
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
    },
    async paginateExams(pagination) {
      await this.$store.commit('tuevs/exams/setPagination', {
        ...this.examsPagination,
        page: pagination.page,
        per_page: pagination.per_page
      })
      await this.searchExams()
    },
    async searchExams() {
      let filterApi = [...this.filters];
      let hasIntegrationFilter = filterApi.some(f => f[0] === "integration");
      let hasCodeFilter = filterApi.some(f => f[0] === "code");

      if (!hasIntegrationFilter && hasCodeFilter) {
        if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
          filterApi.push(['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]);
        }
      }
      
      await this['tuevs/exams/listAll']({
        ...this.examsPagination,
        exam_type: 'observation',
        filters: filterApi
      })

      this.showDetails = []
      this.showLogs = []
      this.logItems = []

      await this.searchDeXparas()
      await this.loadIntegrationsCodes()
    },
    async searchDeXparas() {
      let filters = [
        ['tuevs_exam_id', 'IN', this.exams.reduce((acc, current) => [...acc, current.id], [])],
        ['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]
      ]
      if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
        await this['dexpara/result/listAll']({
          per_page: this.examsPagination.per_page * 2,
          filters: JSON.stringify(filters)
        })
      }
    },
    getDeXpara(tuevs_exam_id, integration_id) {
      if (this.deXparas && Array.isArray(this.deXparas)) {
        return this.deXparas.find(exam => {
          return exam.vns_integration_id === integration_id && exam.tuevs_exam_id === tuevs_exam_id
        })
      }
      return null
    },
    async loadIntegrationsCodes() {
      if (this.exams && Array.isArray(this.exams)) {
        const exams = this.exams.map(exam => {
          const origin = this.getDeXpara(exam.id, this.integrationsSelected.origin)
          exam.origin_code = origin ? origin.code : null
          exam.origin_has_custom_parse = !!(origin && origin.has_custom_parse)
          exam.integration_helpers_id = origin ? origin.integration_helpers_id : null

          const destination = this.getDeXpara(exam.id, this.integrationsSelected.destination)
          exam.destination_code = destination ? destination.code : null
          exam.destination_has_custom_parse = !!(destination && destination.has_custom_parse)
          exam.integration_helpers_id = destination ? destination.integration_helpers_id : null

          return exam
        })
        this.$store.commit('tuevs/exams/setAll', exams)
      }
    },
    async updateIntegrations(evt) {
      this.integrationsSelected.origin = this.integrationsSelected.destination = null

      let originLabel = this.$t('dexpara.resultado.exams.origem')
      if (evt.origin) {
        originLabel = evt.origin.label
        this.integrationsSelected.origin = evt.origin.value
      }

      let destinationLabel = this.$t('dexpara.resultado.exams.destino')
      if (evt.destination) {
        destinationLabel = evt.destination.label
        this.integrationsSelected.destination = evt.destination.value
      }

      this.fields = [{key: 'origin', label: originLabel}, {key: 'destination', label: destinationLabel}]

      await this.searchDeXparas()
      await this.loadIntegrationsCodes()
    },
    async persistDeXParaCopy(evt) {
      this.copySelected = evt;

      if (this.copySelected.integration_type === null || this.copySelected.integration_to === null) {
          this.$snotify.error(this.$t('dexpara.copia.erro.vazio'))
          return;
      }

      if (this.copySelected.integration_type.value === 'origin' && !this.integrationsSelected.origin) {          
          this.$snotify.error(this.$t('dexpara.copia.erro.integracao_origem'))
          return;
      }

      if (this.copySelected.integration_type.value === 'destiny' && !this.integrationsSelected.destination) {
          this.$snotify.error(this.$t('dexpara.copia.erro.integracao_destino'))
          return;
      }

      this.$snotify.clear()
      this.$snotify.confirm(
          this.$t('dexpara.copia.confirmacao.mensagem'),
          this.$t('dexpara.copia.confirmacao.titulo'),
          {
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            buttons: [
              {
                text: this.$t('dexpara.copia.sim'),
                action: async toast => {
                  this.$snotify.remove(toast.id)
                  if (this.filters.length > 0) {
                    await this['tuevs/exams/findByType']({        
                      exam_type: 'observation',
                      filters: this.filters
                    })
                  }

                  let filterExams = [
                    ['tuevs_exam_id', 'IN', this.examsByType.reduce((acc, current) => [...acc, current.id], [])]
                  ]
                  
                  await DeXParaRepository.postCopy(
                    {
                      copy: this.copySelected,
                      integrations: this.integrationsSelected,          
                      exams: filterExams
                    }
                  ).then(async () => {
                    this.$snotify.success(this.$t('dexpara.copia.sucesso'))
                  }).catch(error => {
                    this.$snotify.error(this.$t('dexpara.copia.erro.copiar'))
                  })
                },
                bold: true
              },
              {
                text: this.$t('dexpara.copia.nao'),
                action: toast => {
                  this.$snotify.remove(toast.id)
                },
                bold: true
              }
            ]
          }
      )
    },
    async persistDeXPara() {
      let parsedIntegrations = []

      if (this.integrationsSelected.origin) {
        let integrationId = this.integrationsSelected.origin
        this.exams.filter(e => e.origin_code !== null)
            .map(exam => {
              let dexpara = {
                tuevs_exam_id: exam.id,
                integrations: [{
                  id: integrationId,
                  code: exam.origin_code,
                  has_custom_parse: exam.origin_has_custom_parse,
                  integration_helpers_id: exam.integration_helpers_id
                }]
              }
              if (this.getDeXpara(exam.id, integrationId) && exam.origin_code === '') {
                dexpara = {...dexpara, delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (this.integrationsSelected.destination) {
        let integrationId = this.integrationsSelected.destination
        this.exams.filter(e => e.destination_code !== null)
            .map(exam => {
              let dexpara = {
                tuevs_exam_id: exam.id,
                integrations: [{
                  id: integrationId,
                  code: exam.destination_code,
                  has_custom_parse: exam.origin_has_custom_parse,
                  integration_helpers_id: exam.integration_helpers_id
                }]
              }
              if (this.getDeXpara(exam.id, integrationId) && exam.destination_code === '') {
                dexpara = {...dexpara, delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (parsedIntegrations.length > 0) {
        await DeXParaRepository.post({exams: parsedIntegrations}).then(async () => {
          this.$snotify.success(this.$t('dexpara.resultado.exams.sucesso'))
          await this.searchExams()
        })
      }
    }
  },
  async beforeMount() {
    this.permissions = await getPermissionsFromActualPerfil();
    this.canAccessRoot = await hasPerfil('root');
  },
  async mounted() {
    await this.$store.commit('tuevs/exams/setPagination', {...this.examsPagination, page: 1})
    await this['integrationHelper/listAll']()
    await this.searchExams()
    this['integration/search']()
  }
}
</script>

<style lang="scss" scoped>
.sticky-top {
  top: 1.5rem;

  @media only screen and(max-width: 768px) {
    order: -1;
  }
}

.border {
  border: 1px solid #d1d3e2 !important;
}
</style>
